import { Injectable } from '@angular/core';
import { QueryParamsProvider } from '@domain/routing';
import { Dictionary } from '@shared';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable()
export class SearchState {
	private searchStates: Dictionary<BehaviorSubject<string | null>> = {};

	public constructor(private queryParamsProvider: QueryParamsProvider) {}

	public set(tableName: string, searchTerm: string): void {
		if (this.searchStates[tableName]) {
			this.searchStates[tableName].next(searchTerm);
		} else {
			throw new Error('Search state should be initialized');
		}
	}

	public get(tableName: string): Observable<string | null> {
		if (!this.searchStates[tableName]) {
			// if null is returned to the caller just skip the code
			this.searchStates[tableName] = new BehaviorSubject(null);
		}
		return this.searchStates[tableName].asObservable();
	}

	public resetParentSearch(): void {
		if (this.searchStates[this.queryParamsProvider.parentTableName]) {
			this.searchStates[this.queryParamsProvider.parentTableName].next(null);
		}
	}

	public resetChildTableSearch(): { stopSubscription: () => void } {
		let parentState: string | null;
		const parentStateSubscription = this.get(this.queryParamsProvider.parentTableName).subscribe(
			(selectedParentState: string | null) => {
				parentState = selectedParentState;

				Object.keys(this.searchStates).forEach((key) => {
					if (key !== this.queryParamsProvider.parentTableName) {
						this.searchStates[key].next(null);
					}
				});
			}
		);

		this.searchStates[this.queryParamsProvider.parentTableName].next(parentState);

		return {
			stopSubscription: () => parentStateSubscription.unsubscribe()
		};
	}

	public isSearchApplied$(tableName: string): Observable<boolean> {
		return this.get(tableName).pipe(map((searchKeywords: string | null) => searchKeywords !== null));
	}
}
